import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { AuthContainerComponent } from './auth-container.component';
import { LoginComponent } from './components/login/login.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LoginRequestVM } from 'src/app/viewModels/login/login-request-vm';
import { AuthService } from './services/auth/auth.service';
import { HttpClientModule } from '@angular/common/http';
import { ApiEndPoints } from './common/apiUrls/api-end-points';
import { TokenValidateRequestVM } from 'src/app/viewModels/login/token-validate-request-vm';
import { SharedModule } from 'src/app/middleware/shared/shared.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ChangePasswordComponent } from './components/changePassword/change-password.component';
import { ForgotPasswordComponent } from './components/forgotPassword/forgot-password.component';
import { MatRadioModule } from '@angular/material/radio';
//import { Constants,ConstantsStaging,ConstantsProd } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { Constants} from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { ResetPasswordReqVM } from 'src/app/viewModels/resetPassword/reset-password-req-vm';
import { EmailVM } from 'src/app/viewModels/common/email-vm';
import { UpdateForgotPasswordComponent } from './components/updateForgotPassword/update-forgot-password.component';
import { UpdatePasswordVM } from 'src/app/viewModels/updatePassword/update-password-vm';
import { UserRegistrationInviteComponent } from './components/UserRegistrationInvite/UserRegistrationInvite.component';
import { constants } from 'buffer';
import { PortalLoginComponent } from './components/PortalLogin/PortalLogin.component';
import { VerifyIPComponent } from './components/VerifyIP/VerifyIP.component';
import {
  RecaptchaModule,
  RECAPTCHA_SETTINGS,
  RecaptchaSettings,
  RecaptchaFormsModule,
  RecaptchaV3Module
} from 'ng-recaptcha';

const RECAPTCHA_V2_Site_KEY = '6Le1J78pAAAAAGLxOiF_QDZRQN_kg1ptfOXCyh-q';

@NgModule({
  declarations: [AuthContainerComponent, LoginComponent,UserRegistrationInviteComponent, ChangePasswordComponent, ForgotPasswordComponent, UpdateForgotPasswordComponent,
    PortalLoginComponent,VerifyIPComponent],
  imports: [
    CommonModule,
    AuthRoutingModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    FlexLayoutModule,
    MatProgressSpinnerModule,
    HttpClientModule,
    SharedModule,
    MatRadioModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    RecaptchaV3Module
  ],
  providers: [
    LoginRequestVM,
    AuthService,
    ApiEndPoints,
    TokenValidateRequestVM,
    Constants,
    // ConstantsStaging,
    // ConstantsProd,
    ResetPasswordReqVM,
    EmailVM,
    UpdatePasswordVM,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: RECAPTCHA_V2_Site_KEY
      } as RecaptchaSettings
    }
  ]
})
export class AuthModule { }
